import {booleanAttribute, ChangeDetectionStrategy, Component, computed, input} from "@angular/core";

type Type = 'info-transparent' | 'info' | 'advarsel' | 'feil';

/** Viser melding, for bruk i innhold. */
@Component({
    selector: 'inline-melding',
    templateUrl: './inline-melding.html',
    styleUrls: ['./inline-melding.scss'],
    host: {
        '[class]': 'type()',
        '[class.voksHorisontalt]': 'voksHorisontalt()'
    },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InlineMeldingKomponent {

    voksHorisontalt = input(false, {transform: booleanAttribute});
    type = input<Type>('info');

    ikon = computed(() => this.beregnStilklasse());

    //private hjelpemetoder

    private beregnStilklasse() {
        switch (this.type()) {
            case 'info-transparent':
            case 'info':
                return 'icon ion-ios-information-outline';
            default:
                return 'icon icon ion-android-warning';
        }
    }

}
